import { useMemo } from 'react';

import { useSelector } from 'react-redux';

export const useMultipleSelect = ({ fallback, map, selector, transform }) => {
  const state = useSelector(selector);

  const values = useMemo(() => {
    const result = {};
    const entries = Object.entries(map);

    for (const [to, from] of entries) {
      result[to] = state[from] ?? fallback?.[to];

      if (transform && typeof transform[to] === 'function') {
        result[to] = transform[to](result[to]);
      }
    }

    return result;
  }, [map, state, fallback]);

  return { values };
};
